import { Button, Typography } from 'antd';
import styled from 'styled-components';

const { Link } = Typography;

export const StyledLink = styled(Link)`
  line-height: 18px;
`;

export const StyledDiv = styled.div`
  min-width: 88px;
`;

export const StyledAlertId = styled.div`
  font-size: 10px;
  font-weight: 700;
  max-width: 160px;
`;

export const StyledButton = styled(Button)`
  font-size: 12px;
  color: #2b73e0;
  border-color: #2b73e0;
  background: #fff;
  padding: 4px 12px;
  width: 110px;
  transition: width 5s ease;

  svg {
    margin-right: 4px;
  }

  &:disabled,
  &:disabled:hover {
    color: #4776a2;
  }

  &:not([disabled]):hover {
    color: #fff !important;
    background: #2b73e0 !important;
    border-color: #2b73e0 !important;
    svg {
      fill: #fff;
    }
  }
`;

export const BulkIconContainer = styled.div`
  background-color: #eef4fa;
  padding: 8px 12px;
  border-radius: 50px;
`;
